// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsOverstockSaleStyles {
    container?: InjectableCss;
    subTitleText?: TypographyProps;
    titleText?: TypographyProps;
}

export const productDetailsOverstockSaleStyles: ProductDetailsOverstockSaleStyles = {};

const styles = productDetailsOverstockSaleStyles;

const ProductDetailsOverstock: React.FC<Props> = ({ product }) => {
    if (!product || !product?.properties?.overstockSale) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} className="overstock">
            <Typography {...styles.titleText} data-test-selector="productDetails_overstockSale">
                {translate("Overstock Sale!")}
            </Typography>
            <Typography {...styles.subTitleText}>
                {translate("Item price and availability limited to current stock.")}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsOverstock),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
